import(/* webpackMode: "eager" */ "/app/src/app/(providers)/(private)/(callNotification)/loading.tsx");
